import { animate, inView, stagger, timeline, spring } from "motion";

export default function initAnimations() {
  inView(".content-module", ({ target }) => {
    animate(
      target.querySelectorAll(
        ".section-title, .section-intro, .body-text, .btn-primary, .btn-custom, .slogan"
      ),
      { opacity: 1, transform: "none" },
      // { delay: stagger(0.2), duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
      { duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
    );
  });

  inView(".footer", ({ target }) => {
    animate(
      target.querySelectorAll(".footer-main-info, .footer-contacts"),
      { opacity: 1, transform: "none" },
      { delay: stagger(0.2), duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
    );
  });

  inView(".all-projects", ({ target }) => {
    animate(
      target.querySelectorAll(
        ".section-title, .projects-info, .all-projects-list"
      ),
      { opacity: 1, transform: "none" },
      { delay: stagger(0.2), duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
    );
  });

  inView(".module-gallery", ({ target }) => {
    animate(
      target.querySelectorAll(".gallery-slider"),
      { opacity: 1, transform: "none" },
      { duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
    );
  });

  inView(".module-selected-objects", ({ target }) => {
    animate(
      target.querySelectorAll(".section-title"),
      { opacity: 1, transform: "none" },
      { duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
    );
    animate(
      target.querySelectorAll(".btn-primary"),
      { opacity: 1, transform: "none" },
      { duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
    );

    animate(
      target.querySelectorAll(".objects-list > li"),
      { opacity: 1, transform: "none" },
      { delay: stagger(0.2), duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
    );
  });

  inView(".all-objects", ({ target }) => {
    animate(
      target.querySelectorAll(".section-title"),
      { opacity: 1, transform: "none" },
      { duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
    );
    animate(
      target.querySelectorAll(".object-facets"),
      { opacity: 1, transform: "none" },
      { duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
    );

    animate(
      target.querySelectorAll(".objects-list > li"),
      { opacity: 1, transform: "none" },
      { delay: stagger(0.2), duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
    );
  });

  inView(".contact-module", ({ target }) => {
    animate(
      target.querySelectorAll(
        ".section-title, .contact-form-title, .form-wrap"
      ),
      { opacity: 1, transform: "none" },
      { duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
    );
    animate(
      target.querySelectorAll(".contacts-list > li"),
      { opacity: 1, transform: "none" },
      { delay: stagger(0.2), duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
    );
  });

  function reinitAnimations() {
    inView(".all-objects", ({ target }) => {
      animate(
        target.querySelectorAll(".objects-list > li"),
        { opacity: 1, transform: "none" },
        { delay: stagger(0.2), duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
      );
    });
  }

  document.addEventListener("facetwp-loaded", function () {
    reinitAnimations();
  });
}
